import axios from "axios";
import * as Endpoints from "../entities/Endpoints";
import config from "../config/config";
import { SKIP_TOKEN_URLS } from "../../src/utils/Constant/Constant";

// Base instance for Stripe public API
const axiosStripePublicInstance = axios.create({
  baseURL: Endpoints.STRIPE_PUBLIC_API_ENDPOINT,
});

// 🔹 Refresh Token helper (reuse same logic)
const refreshTokenLogin = async () => {
  const refreshToken = localStorage.getItem("RefreshToken");
  if (!refreshToken) return null;

  try {
    const tenant = config.CUSTOME_TENANT_NAME;
    const policy = config.CUSTOME_POLICY_NAME;
    const clientId = config.MSAL_CLIENT_ID;
    const scope = config.SCOPE_USER_READWRITE_ALL;

    const b2cloginURL = `https://${tenant}.b2clogin.com/${tenant}.onmicrosoft.com/${policy}/oauth2/v2.0/token`;

    const body = new URLSearchParams({
      grant_type: "refresh_token",
      refresh_token: refreshToken,
      client_id: clientId,
      scope: `${scope} openid offline_access`,
    }).toString();

    const response = await fetch(b2cloginURL, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body,
    });

    const data = await response.json();

    if (!response.ok) throw new Error(data.error_description || "Refresh failed");
    if (!data.access_token) throw new Error("No access token received");

    // Save new tokens
    localStorage.setItem("Token", data.access_token);
    localStorage.setItem("RefreshToken", data.refresh_token || "");
    localStorage.setItem("TokenTimestamp", new Date().getTime());

    return data.access_token;
  } catch (err) {
    console.error("Refresh token error:", err.message);
    return null;
  }
};

//  Request Interceptor (attach token)
axiosStripePublicInstance.interceptors.request.use(
  async (config) => {

    const coachUrl = (config.baseURL || "") + config.url;

    // Skip token check for coach onboarding process
    if (SKIP_TOKEN_URLS.some(skipUrl => coachUrl.includes(skipUrl))) {
      return config;
    }

    let token = localStorage.getItem("Token");

    const tokenExpiryTime = 10 * 60 * 1000; // 10 mins
    const tokenTimestamp = Number(localStorage.getItem("TokenTimestamp"));
    const currentTime = new Date().getTime();

    if (!token || (tokenTimestamp && currentTime - tokenTimestamp > tokenExpiryTime)) {
      token = await refreshTokenLogin();
      if (!token) {
        localStorage.clear();
        window.location.href = "/";
        return Promise.reject("Session expired. Please log in again.");
      }
    }

    if (token) config.headers.Authorization = `Bearer ${token}`;
    return config;
  },
  (error) => Promise.reject(error)
);

// 🔹 Response Interceptor (handle 401)
axiosStripePublicInstance.interceptors.response.use(
  (response) => response,
  async (error) => {
    const originalRequest = error.config;
    if (error.response?.status === 401 && !originalRequest._retry) {
      originalRequest._retry = true;
      const token = await refreshTokenLogin();
      if (token) {
        originalRequest.headers.Authorization = `Bearer ${token}`;
        return axiosStripePublicInstance(originalRequest);
      }
      localStorage.clear();
      window.location.href = "/login";
    }
    console.error("Stripe Public API Error:", error.response || error.message);
    return Promise.reject(error.response || error.message);
  }
);


export default axiosStripePublicInstance;
